import {atom} from 'recoil';

export const managerListModalAtom = atom<boolean>({
  key: 'managerListModalAtom',
  default: false,
});
